import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { morePanelGroups } from "../pages";
import { useMobileMode } from "../MobileModeContext.jsx";
import { AdminContext } from "../../adminSession.jsx";
import "../mobile.css";

// The phone home (replaces the six-button MobileMenuPage when the phone app is on). Job Entry
// is not here (Mike, 2026-10-08; Shipping joined the shop floor 2026-10-29). Operators see the shop floor first; an
// unlocked admin sees the office first. The admin Home tab becomes the Dashboard once that
// page is switched on for phones.
export default function PhoneHome() {
  const mode = useMobileMode();
  const admin = useContext(AdminContext);
  const isAdmin = Boolean(admin && admin.isAdminActive);
  const groups = morePanelGroups(mode.features);
  const ordered = isAdmin ? [...groups].reverse() : groups;

  return (
    <div className="jq-screen" data-testid="phone-home">
      {ordered.map((g) => (
        <section key={g.title} className="jq-home-section" aria-label={g.title}>
          <h2 className="jq-section-title">{g.title}</h2>
          <div className="jq-tiles">
            {g.pages.map((p) => (
              <Link key={p.key} to={p.path} className="jq-tile">
                <i className={`fas ${p.icon}`} aria-hidden="true" />
                <span>{p.label}</span>
                {p.admin && !isAdmin && <i className="fas fa-lock jq-tile-lock" aria-label="needs the admin PIN" />}
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
